<div class="modal-header">
    <h4 class="modal-title">{{ "modales.payment.title" | translate }}</h4>
</div>
<div class="modal-body">
    <div class="contentContainer">
        <div class="text">
            {{ "modales.payment.text" | translate }}
        </div>
    </div>
</div>
<div class="modal-footer">
    <button (click)="goToPayment()" type="button" class="btn btn-primary">
        {{ "modales.payment.seePacksBtn" | translate }}
    </button>
    <button (click)="goToHome()" type="button" class="btn btn-secondary">
        {{ "modales.payment.notNowBtn" | translate }}
    </button>
</div>
